import styled from 'styled-components';
import { colors, getMediumRGBA } from '../../../../styles/colors';
import { fontFamily, radii, space, text } from '../../../../styles/onboardingUiTokens';
import { formFieldBorderOpacity, formFieldBorderWidthPx, formFieldControlMinHeightPx } from '../forms/formFieldTokens';
import { SvgIcon } from '../icons/SvgIcon';

const Root = styled.button`
  appearance: none;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  width: 100%;
  box-sizing: border-box;
  min-height: ${formFieldControlMinHeightPx}px;
  padding: ${space.xs} 10px;
  border-radius: ${radii.control};
  border: ${formFieldBorderWidthPx}px solid ${getMediumRGBA(formFieldBorderOpacity)};
  background: ${colors.white};
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${getMediumRGBA(0.3)};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

// Wraps instead of truncating, so the end of a long name, such as a "(privat)" tag, stays readable.
const InsuranceName = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: break-word;
  font-family: ${fontFamily.ubuntu};
  font-size: ${text.body.fontSize};
  line-height: ${text.body.lineHeight};
  font-weight: ${text.body.fontWeight};
  color: ${colors.dark};
`;

const ChangeLabel = styled.span`
  flex: 0 0 auto;
  font-family: ${fontFamily.ubuntu};
  font-size: ${text.mini.fontSize};
  line-height: ${text.mini.lineHeight};
  font-weight: 400;
  color: ${colors.medium};
  white-space: nowrap;
`;

const ChevronDown = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
`;

export type SelectedInsuranceButtonProps = {
  insuranceName: string;
  onChangeRequest: () => void;
  disabled?: boolean;
};

export function SelectedInsuranceButton({ insuranceName, onChangeRequest, disabled = false }: SelectedInsuranceButtonProps) {
  return (
    <Root type="button" disabled={disabled} aria-label="Krankenkasse ändern" onClick={onChangeRequest}>
      <InsuranceName>{insuranceName}</InsuranceName>
      <ChangeLabel>ändern</ChangeLabel>
      <ChevronDown aria-hidden>
        <SvgIcon name="arrowright" size={24} primaryColor={colors.medium} />
      </ChevronDown>
    </Root>
  );
}
